import { MinusIcon, TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import type { IconProps } from '@chakra-ui/react';
import type { leagueMember } from '@/models/user';

export function RankChangeIndicator(
  props: {
    memberData: leagueMember;
    getListPosition: () => number;
    /** Lighter arrows on green highlight rows (still green up / red down). */
    onHighlight?: boolean;
  } & Omit<IconProps, 'color'>,
) {
  const { memberData, getListPosition, onHighlight, ...rest } = props;
  const prevRank = memberData.prevRank > 0 ? memberData.prevRank : getListPosition() + 1;
  const upColor = onHighlight ? 'green.200' : 'green.500';
  const downColor = onHighlight ? 'red.200' : 'red.500';
  const flatColor = onHighlight ? 'whiteAlpha.800' : 'orange.400';

  if (memberData.currentRank < prevRank) {
    return <TriangleUpIcon color={upColor} {...rest} />;
  }
  if (memberData.currentRank > prevRank) {
    return <TriangleDownIcon color={downColor} {...rest} />;
  }
  return <MinusIcon color={flatColor} {...rest} />;
}
